module.exports = __webpack_public_path__ + "static/media/icMenu.b66dd2fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/icMenu.svg
// module id = 783
// module chunks = 0